module.exports = __webpack_public_path__ + "static/media/company.8b306fd0.svg";